<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<app-logo-card-page [style]="style">
    <app-email-verify [address]="address" (onSuccess)="onSuccess()"></app-email-verify>
</app-logo-card-page>